import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localePt, 'pt');

import { QuillModule } from 'ngx-quill';

import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
import { htmlEditButton } from 'quill-html-edit-button';

const font = Quill.import('attributors/class/font');
// We do not add Aref Ruqaa since it is the default
font.whitelist = [
  'arial',
  'roboto',
  'serif',
  'verdana',
  'georgia',
  'times',
  'sansserif',
  'monospace',
  'tahoma',
];
Quill.register(font, true);
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/htmlEditButton', htmlEditButton);

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ColorPickerModule } from 'ngx-color-picker';
import { FileUploadModule } from 'ng2-file-upload';

import { NgxMaskModule } from 'ngx-mask';
import {
  CurrencyMaskModule,
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG,
} from 'ng2-currency-mask';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { NgSelectModule } from '@ng-select/ng-select';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
//chart
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';

//pipe
import { FilterPipe } from './pipe/filter';

//component
import { LoginformComponent } from './loginform/loginform.component';
import { MainComponent } from './main/main.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrderslistComponent } from './dashboard/orderslist/orderslist.component';
import { ApiService } from './services/api.service';
import { OperadorService } from './services/operador.service';
import { ConfigurationComponent } from './configuration/configuration.component';
import { OrderComponent } from './order/order.component';
import { StockComponent } from './stock/stock.component';
import { ProductComponent } from './product/product.component';
import { ImagePreview } from './ImagePreview.directive';
import { VideoPreview } from './VideoPreview.directive';
import { CouponComponent } from './coupon/coupon.component';
import { DiscountsComponent } from './discounts/discounts.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { ShowcaseRegisterComponent } from './showcase-register/showcase-register.component';
import { SubcategoriaItemComponent } from './components/subcategoria-item/subcategoria-item.component';
import { CustomerComponent } from './customer/customer.component';
import { CustomersComponent } from './customers/customers.component';
import { SettingsComponent } from './settings/settings.component';
import { DesignComponent } from './settings/design/design.component';
import { BannerRotativeComponent } from './settings/design/banner-rotative/banner-rotative.component';
import { BannerRotativeRegisterComponent } from './settings/design/banner-rotative-register/banner-rotative-register.component';
import { PedidosComponent } from './dashboard/pedidos/pedidos.component';
import { RupturasComponent } from './dashboard/rupturas/rupturas.component';
import { AvaliacoesComponent } from './dashboard/avaliacoes/avaliacoes.component';
import { PorlojaComponent } from './dashboard/porloja/porloja.component';
import { AvaliacoesGraphComponent } from './dashboard/avaliacoes-graph/avaliacoes-graph.component';
import { IndicatorsComponent } from './main/indicators/indicators.component';
import { ShippingDeliveryComponent } from './settings/shipping-delivery/shipping-delivery.component';
import { PromotionComponent } from './promotion/promotion.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { CouponsComponent } from './coupons/coupons.component';
import { DriveThruComponent } from './settings/drive-thru/drive-thru.component';
import { CollaboratorsComponent } from './settings/collaborators/collaborators.component';
import { TvDashboardComponent } from './tv-dashboard/tv-dashboard.component';
import { BannersComponent } from './settings/design/banners/banners.component';
import { BannersRegisterComponent } from './settings/design/banners-register/banners-register.component';
import { PersonalizacaoComponent } from './settings/design/personalizacao/personalizacao.component';
import { ParametersComponent } from './settings/parameters/parameters.component';
import { ProductOffersComponent } from './components/product-offers/product-offers.component';

import { AgmCoreModule } from '@agm/core';
import { AccessManagerComponent } from './access-manager/access-manager.component';
import { AccessRegisterComponent } from './access-register/access-register.component';
import { PaymentMethodsComponent } from './settings/payment-methods/payment-methods.component';
import { CategoriesComponent } from './settings/categories/categories.component';
import { DataImportComponent } from './settings/data-import/data-import.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { ImportFileComponent } from './components/import-file/import-file.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.',
};

@NgModule({
  declarations: [
    FilterPipe,
    AppComponent,
    LoginformComponent,
    MainComponent,
    DashboardComponent,
    OrderslistComponent,
    ConfigurationComponent,
    OrderComponent,
    StockComponent,
    ProductComponent,
    ImagePreview,
    VideoPreview,
    CouponComponent,
    DiscountsComponent,
    ShowcaseComponent,
    ShowcaseRegisterComponent,
    SubcategoriaItemComponent,
    CustomerComponent,
    CustomersComponent,
    SettingsComponent,
    DesignComponent,
    BannerRotativeComponent,
    BannerRotativeRegisterComponent,
    PedidosComponent,
    RupturasComponent,
    AvaliacoesComponent,
    PorlojaComponent,
    AvaliacoesGraphComponent,
    IndicatorsComponent,
    ShippingDeliveryComponent,
    PromotionComponent,
    PromotionsComponent,
    CouponsComponent,
    DriveThruComponent,
    CollaboratorsComponent,
    TvDashboardComponent,
    BannersComponent,
    BannersRegisterComponent,
    PersonalizacaoComponent,
    ProductOffersComponent,
    AccessManagerComponent,
    ParametersComponent,
    AccessRegisterComponent,
    PaymentMethodsComponent,
    CategoriesComponent,
    DataImportComponent,
    WelcomeComponent,
    ImportFileComponent,
    ProductDetailComponent,
  ],
  imports: [
    BrowserModule,
    NgApexchartsModule,
    ChartsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    ColorPickerModule,
    FileUploadModule,
    NgxMaskModule.forRoot(),
    CurrencyMaskModule,
    MatTreeModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    NgxBarcode6Module,
    NgSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMomentDateModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    DragDropModule,
    ClipboardModule,
    InfiniteScrollModule,
    QuillModule.forRoot({
      theme: 'snow',
      formats: [
        'bold',
        'size',
        'italic',
        'underline',
        'link',
        'list',
        'blockquote',
        'image',
        'video',
        'color',
        'indent',
        'font',
        'imageResize',
      ],
      modules: {
        toolbar: [
          [
            { size: ['small', false, 'large', 'huge'] },
            {
              font: [
                'arial',
                'roboto',
                'serif',
                'verdana',
                'georgia',
                'times',
                'sansserif',
                'monospace',
                'tahoma',
              ],
            },
          ],
          ['bold', 'italic', 'underline', 'link'],
          ['blockquote', { list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ color: [] }],
          ['image', 'video'],
          ['clean'],
        ],
        clipboard: {
          matchVisual: true,
        },
        htmlEditButton: {
          debug: false, // logging, default:false
          msg: 'Editar o código HTML', //Custom message to display in the editor, default: Edit HTML here, when you click "OK" the quill editor's contents will be replaced
          okText: 'Ok', // Text to display in the OK button, default: Ok,
          cancelText: 'Cancelar', // Text to display in the cancel button, default: Cancel
          buttonHTML: '&lt;&gt;', // Text to display in the toolbar button, default: <>
          buttonTitle: 'Mostrar o código HTML', // Text to display as the tooltip for the toolbar button, default: Show HTML source
          syntax: false, // Show the HTML with syntax highlighting. Requires highlightjs on window.hljs (similar to Quill itself), default: false
        },
        imageResize: {},
      },
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCeBTHNqiyLF4TRDBVU8cQZAJdQyW90a2o',
    }),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt',
    },
    ApiService,
    OperadorService,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
